/* eslint-disable max-len */

import TableList from '@/inheritance/table-list';

export default {
  /**
   * Nombre del componente
   */
  name: 'Issues',

  /**
   * Extendemos la funcionalidad del listado de tablas desde src/inheritance/table-list.js
   */
  extends: TableList,

  /**
   * @override
   */
  data() {
    return {
      listSearching: false
    };
  },
  methods: {
    /**
     * Obtenemos la lista de usuarios desde el servicio
     * @param {String} sort Orden asc/desc
     * @param {Object} cfg Configuración de filtros
     */
    loadItems(sort = this.orderby, cfg = {}) {
      if (this.filters && Object.keys(this.filters).length) {
        cfg.params = {
          $filter: JSON.stringify(this.filters)
        };
      }
      const payload = {
        section: 'issues',
        cfg
      };

      if (sort && sort !== 'false') {
        payload.sort = sort;
      }

      this.listSearching = true;
      this.loadData(payload)
        .then(res => {
          this.metadata = res.metadata;
          this.items = this.mapSelfName(res.data.issues, ['subject']);
          this.getColumns();
          this.filterColums()
          this.calculateColumnsWith(this.columns);
        })
        .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`))
        .finally(() => {
          this.listSearching = false;
          this.$nextTick(() => {
            if (!this.tableHasScroll()) {
              this.infiniteScroll();
            }
          });
        });
    },

    /**
     * @override
     */
    colsChange(cols) {
      this.columns = cols;
      this.saveFilterInLocalstore(cols, 'col_issu');
    },

    /**
     * Ordenamos la tabla por un campo específico
     * @param {String} field Orden de la tabla
     */
    sort(field) {
      this.orderby = field;
      let cfg = {};
      if (this.filters && Object.keys(this.filters).length) {
        cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
      }
      this.loadItems(field, cfg);
      if (field && field !== 'false') {
        this.saveFilterInLocalstore(field, 'ob_issu');
      } else {
        this.removeFromLocalstore('ob_issu');
      }
    },

    /**
     * Se eliminan los items eliminados del listado
     * @param {Array} uuidsDeletedItems Uuids de los items eliminados
     */
    filterDeletedItems(uuidsDeletedItems) {
      this.items = this.items.filter(item => !uuidsDeletedItems.includes(item.uuid));
    },

    /**
     * FILTRO DE RESULTADOS
     * Aplicamos los filtros seleccionados. Guardamos en localStore una variable con los filtros aplicados,
     * para que cuando el usuario cambie de sección y vuelva de nuevo a este listado, se carguen
     * los resultados que había filtrado.
     * @param {Array} filters Filtros para aplicar
     */
    filter(filters) {
      this.saveFilterInLocalstore(filters, 'filt_issu');
      if (filters.length >= 1) {
        this.tbFilters = filters;
        const customFilters = [
          { field: 'key_status', _function: this.translateStatusFilterInputs },
          { field: 'blocking', _function: this.translateBlockingFilterInputs }
        ];
        this.applyFilters(filters, customFilters);
        const cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
        this.loadItems(this.orderby, cfg);
      } else {
        delete this.filters;
        this.loadItems();
      }
    },

    /**
     * Si el usuario ha introducido inputs en Español para filtrar el bloqueante, lo traducimos al input correcto
     * @param {Array} filter Filtro
     */
    translateBlockingFilterInputs(filter) {
      switch (filter.conditionValue.toLowerCase()) {
        case 'si':
        case 'verdadero':
        case 'bloqueado':
          filter.conditionValue = true;
          break;
        case 'no':
        case 'falso':
        case 'desbloqueado':
          filter.conditionValue = false;
          break;
        default:
          break;
      }
    },
    /**
     * Si el usuario ha introducido inputs en Español para filtrar el estado, lo traducimos al input correcto
     * @param {Array} filter Filtro
     */
    translateStatusFilterInputs(filter) {
      switch (filter.conditionValue.toLowerCase()) {
        case 'en progreso':
          filter.conditionValue = 'IN-PROGRESS';
          break;
        case 'pendiente':
          filter.conditionValue = 'OPEN';
          break;
        case 'resuelta':
          filter.conditionValue = 'RESOLVED';
          break;
        default:
          break;
      }
    },
    /**
     * @override
     * SCROLL INFINITO
     * Método que se ejecuta cuanto el usuario ha hecho scroll y ha llegado al final de la tabla.
     * Se llama al método heredado 'pagination' y devuelve un array de resultados, los cuales
     * se 'mezclan' con los resultados que tenía la tabla.
     */
    infiniteScroll() {
      if (this.listSearching) {
        return;
      }
      const payload = {
        section: 'issues',
        href: this.metadata.paging._links._next.href
      };
      if (payload.href && !this.isLoading) {
        this.pagination(payload)
          .then(res => {
            this.metadata = res.metadata;
            this.items = [...this.items, ...this.loadDataInTable(res.data.issues, ['subject'])];
          })
          .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
      }
    },
    /**
     * Añade los filtros obtenidos de localStorage a la petición inicial
     * @param {Object} tbFilters filtros guardados en storage
     */
    addFiltersToRequest(tbFilters) {
      // Se añaden los filtros a la petición si están en el storage
      this.filters = [];
      tbFilters.forEach(filtro => {
        const condition = filtro.condition;
        this.filters.push({
          field: filtro.field,
          condition,
          conditionValue: filtro.conditionValue
        });
      });
      this.applyFilters(this.filters);
    },

    doSearch(val) {
      this.search = val;
      this.saveFilterInLocalstore(val, 'search_issu');
      this.loadItems();
    },

    filterColums() {
      this.columns = this.columns.filter(col => {
        return ![
          'uuid',
          'uuid_group_assigned',
          'uuid_user_assigned'
        ].includes(col.field);
      });
    },

    handleLoadView(view) {
      this.filters = null;
      this.tbFilters = [];
      this.orderby = '';
      this.removeFromLocalstore('filt_issu');
      this.removeFromLocalstore('ob_issu');
      this.removeFromLocalstore('col_issu');
      this.removeFromLocalstore('search_issu');
      this.loadView(view);
    }
  },
  /**
   * @override
   */
  beforeMount() {
    this.section = 'issues';
    this.loadSectionViews();
  },

  /**
   * Configuración inicial del componente
   * 1. Asignamos las columnas por defecto del listado de la tabla
   * 2. Obtenemos los filtros que el usuario pueda haber aplicado con anterioridad
   * 3. Obtenemos la información de la tabla
   * 4. Borramos la información de formularios anteriores que pueda estar guardada
   */
  mounted() {
    this.$root.$on('update-issue-list', () => {
      this.tbFilters = this.loadFilterInLocalstore('filt_issu');
      this.filter(this.tbFilters);
    });
    this.defaultColumns = [
      'uuid',
      'subject',
      'blocking',
      'category',
      'expires_on',
      'status',
      'user_opened',
      'created_on',
      'object_type'
    ];
    this.tbFilters = this.loadFilterInLocalstore('filt_issu');
    this.orderby = this.loadFilterInLocalstore('ob_issu');
    this.search = this.loadFilterInLocalstore('search_issu');

    this.addFiltersToRequest(this.tbFilters);

    if (
      this.orderby &&
      this.orderby !== 'false' &&
      this.orderby.length > 0 &&
      this.orderby !== this.$route.query['sorts-by']
    ) {
      this.$router
        .replace({
          path: this.$route.fullPath,
          query: { 'sorts-by': this.orderby }
        })
        .then(() => {
          this.sort(this.orderby);
        });
    } else {
      this.loadItems();
    }
    this.columns = this.loadFilterInLocalstore('col_issu');
    this.$store.dispatch('formStore/deleteForm', this.$route.name);
  }
};
